import { FormProvider as RHFFormProvider } from "react-hook-form";
import PropTypes from "prop-types";
import { Box, Button, Grid, CircularProgress, Alert } from "@mui/material";

const FormProvider = ({ children, methods, onSubmit, onCancel, submitText, cancelText, isLoading }) => {
  const handleSubmit = methods.handleSubmit(onSubmit);
  const formErrors = methods.formState.errors;

  return (
    <RHFFormProvider {...methods}>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        {formErrors && formErrors.length > 0 && formErrors.map((error, index) => <Alert key={index} severity="error" variant="outlined" sx={{ mb: 1 }}>{error}</Alert>)}
        
        <Grid container spacing={2}>
          {children}
        </Grid>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
          {!!onCancel && (
            <Button
              onClick={onCancel}
              color="inherit"
              disabled={isLoading}
              sx={{ mr: 1 }}
            >
              {cancelText}
            </Button>
          )}

          {!!onSubmit && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
              {submitText}
            </Button>
          )}
        </Box>
      </Box>
    </RHFFormProvider>
  );
};

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  isLoading: PropTypes.bool
};

export default FormProvider;
